var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExodusLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 206,
    viewBox: "0 0 1000 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.107 57.3331L116.665 0V32.0552L172.76 68.5066L166.161 89.3883H116.665V115.948H166.161L172.76 136.83L116.665 173.281V205.337L204.107 148.187L189.808 102.76L204.107 57.3331Z",
    fill: "url(#paint0_linear_1661_261)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5888 115.948H89.9009V89.3883H40.4055L33.9894 68.5066L89.9009 32.0552V0L2.45898 57.3331L16.7577 102.76L2.45898 148.187L90.0842 205.337V173.281L33.9894 136.83L40.5888 115.948Z",
    fill: "url(#paint1_linear_1661_261)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1661_261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 203,
    height: 206
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.107 57.3331L116.665 0V32.0552L172.76 68.5066L166.161 89.3883H116.665V115.948H166.161L172.76 136.83L116.665 173.281V205.337L204.107 148.187L189.809 102.76L204.107 57.3331Z",
    fill: "url(#paint2_linear_1661_261)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.589 115.948H89.9012V89.3883H40.4057L33.9897 68.5066L89.9012 32.0552V0L2.45923 57.3331L16.7579 102.76L2.45923 148.187L90.0845 205.337V173.281L33.9897 136.83L40.589 115.948Z",
    fill: "url(#paint3_linear_1661_261)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1661_261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.56689,
    width: 200.203,
    height: 205.337,
    fill: "url(#paint4_linear_1661_261)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M378.076 56.4673V74.4188H295.347V92.7878H365.639V110.739H295.347V130.917H378.076V148.869H274.124V56.4673H378.076Z",
    fill: "#1F2033"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M389.809 148.869L437.339 102.111L391.156 56.4673H420.374L452.959 89.4479L484.197 56.4673H511.53L465.481 102.111L513.011 148.869H483.523L452.959 114.914L418.085 148.869H389.809V148.869Z",
    fill: "#1F2033"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M570.006 56.4673C608.515 56.4673 631.673 75.7511 631.673 102.668C631.673 129.585 608.515 148.869 570.006 148.869C531.497 148.869 508.471 129.585 508.471 102.668C508.471 75.7511 531.497 56.4673 570.006 56.4673ZM570.006 73.7423C546.848 73.7423 529.777 85.393 529.777 102.668C529.777 119.943 546.848 131.594 570.006 131.594C593.297 131.594 610.368 119.943 610.368 102.668C610.368 85.393 593.297 73.7423 570.006 73.7423Z",
    fill: "#1F2033"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M708.434 56.4673C739.276 56.4673 757.862 73.5838 757.862 102.529C757.862 131.752 739.411 148.869 708.703 148.869H646.211V56.4673H708.434ZM736.044 102.529C736.044 84.4382 725.269 74.4188 705.74 74.4188H667.356V130.917H705.74C725.269 130.917 736.044 120.759 736.044 102.529Z",
    fill: "#1F2033"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M827.799 148.869C795.32 148.869 770.69 134.128 770.69 106.967V56.4673H791.937V104.92C791.937 121.708 809.394 129.488 827.799 129.488C846.339 129.488 863.797 121.844 863.797 104.92V56.4673H884.908V106.967C884.908 134.128 860.414 148.869 827.799 148.869Z",
    fill: "#1F2033"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M944.383 148.869C926.935 148.869 908.124 145.655 894.765 139.629L901.717 122.487C913.713 127.978 930.207 131.46 945.065 131.46C962.104 131.46 978.053 127.844 978.053 121.416C978.053 116.729 973.01 114.72 962.513 113.113L932.797 109.899C909.896 106.819 898.718 98.9184 898.718 84.9912C898.718 67.0466 917.666 56.4673 945.474 56.4673C962.241 56.4673 985.278 59.5473 997.137 64.9039L990.185 81.2416C978.462 76.4206 958.56 74.0102 944.52 74.0102C930.07 74.0102 920.528 77.3581 920.528 83.5182C920.528 87.8034 925.299 89.9461 937.568 91.687L966.466 94.9009C988.549 97.981 1000 105.48 1000 120.077C1000 138.557 975.736 148.869 944.383 148.869Z",
    fill: "#1F2033"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1661_261",
    x1: 175.82,
    y1: 219.454,
    x2: 117.247,
    y2: -22.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1661_261",
    x1: 175.82,
    y1: 219.454,
    x2: 117.247,
    y2: -22.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1661_261",
    x1: 175.82,
    y1: 219.454,
    x2: 117.247,
    y2: -22.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1661_261",
    x1: 175.82,
    y1: 219.454,
    x2: 117.247,
    y2: -22.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1661_261",
    x1: 15.4004,
    y1: 46.2008,
    x2: 116.785,
    y2: 121.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#8952FF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DABDFF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExodusLogoDark);
export default __webpack_public_path__ + "static/media/Exodus_logo_dark.b050c8d2bf3b05cfe6c07b7ec5fef3c5.svg";
export { ForwardRef as ReactComponent };